export enum LanguageDirection {
  LEFT_TO_RIGHT = 'ltr',
  RIGHT_TO_LEFT = 'rtl',
}

export namespace LanguageDirection {
  export function valueOf(str: string): LanguageDirection | undefined {
    const enumKey = LanguageDirection[str];
    return enumKey;
  }
}